import TextField from '@blueshift-ui/inputs/dist/components/text-field';
import { useUserContext } from '@nrdy-marketing-engine/server/src/user/context';
import { Controller, useFormState } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { CartState } from '../../../@types/cart-state';
import { transformMeToClient } from '../../api/user/create-account';
import { useCartContext } from '../../cart-context';
import useCountryCodedValidations from '../../hooks/use-country-coded-validations/use-country-coded-validations';
import { jurisdictionToCountryCode } from '../../lib/country-code/jurisdiction-to-country-code';
import Field from '../shared/field';

function ContactFields() {
  const { user } = useUserContext();
  const client = transformMeToClient(user);
  const {
    useFormVals: { control },
    cartState: { cartJurisdictionId },
  } = useCartContext();

  const formState = useFormState<CartState>({ control });
  const { countryPhoneNumberRules, countryZipCodeRules, countryInputMask, postalCodeLabel } =
    useCountryCodedValidations(jurisdictionToCountryCode(cartJurisdictionId) || 'US');

  return (
    <>
      <Field>
        <Controller
          control={control}
          name="client.email"
          render={({ field: { ref, ...field } }) => (
            <TextField
              disabled
              fullWidth
              label="Email"
              type="email"
              {...field}
              value={client?.email}
            />
          )}
        />
      </Field>

      <Field>
        <Controller
          control={control}
          name="phoneNumber"
          render={({ field: { ref, ...field } }) => (
            <InputMask mask={countryInputMask} maskPlaceholder=" " {...field}>
              {(inputProps) => (
                <TextField
                  error={!!formState.errors.phoneNumber?.message}
                  fullWidth
                  helperText={formState.errors.phoneNumber?.message}
                  InputLabelProps={{ shrink: true }}
                  label="Phone number"
                  type="tel"
                  {...field}
                />
              )}
            </InputMask>
          )}
          rules={countryPhoneNumberRules}
        />
      </Field>

      <Field>
        <Controller
          control={control}
          name="zipCode"
          render={({ field: { ref, ...field } }) => (
            <TextField
              error={!!formState.errors.zipCode?.message}
              fullWidth
              helperText={formState.errors.zipCode?.message}
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 8 }}
              label={postalCodeLabel}
              {...field}
            />
          )}
          rules={countryZipCodeRules}
        />
      </Field>
    </>
  );
}

export default ContactFields;
